export enum IMAGE_WITH_POPUP_TYPE {
	DEFAULT,
	MANUAL_OPPO,
	LOGO,
}
